import React from 'react';

import {
  Box,
  InputLabel as BaseInputLabel
} from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement
} from '@stripe/react-stripe-js';
import {
  Control,
  Controller,
  FieldPath,
  FieldValues
} from 'react-hook-form';


const InputLabel = styled(BaseInputLabel)(({ theme }) => ({
  color: '#486C82',
  fontSize: 12
}));

const StripeInputBox = styled(Box)(props => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  paddingLeft: '12px',
  height: 40,
  border: '1px solid #dcdee6',
  borderRadius: '4px'
}));


const ErrorMessage = styled('span')<{
  children?: React.ReactNode | React.ReactNode[] | string;
}>(() => ({
  color: '#d32f2f',
  fontSize: 12
}));

export interface IStripeElementFieldControllerProps<TFormState extends FieldValues> {
  formControl: Control<TFormState>;
  fieldKey: FieldPath<TFormState>;
  isRequired?: boolean;
  label: React.ReactNode;
  backgroundColor?: string;
}

export function genStripeElementField<TFormState extends FieldValues>(): React.FC<IStripeElementFieldControllerProps<TFormState>> {

  const StripeElementField: React.FC<IStripeElementFieldControllerProps<TFormState>> = props => {

    return (
      <>
        <InputLabel>
          {props.label}
        </InputLabel>

        <Controller
          name={props.fieldKey}
          control={props.formControl}
          rules={{ required: props.isRequired }}
          render={elementProps => {
            const errorMessage: string = elementProps.formState.errors?.[props.fieldKey]?.message?.toString() ?? '';

            return (
              <>
                <StripeInputBox sx={{ backgroundColor: props.backgroundColor ?? '', borderColor: elementProps.formState.errors[props.fieldKey] ? '#d32f2f' : '' }}>
                  {props.fieldKey === 'cardNumber' ?
                    <CardNumberElement
                      onChange={value => {
                        if (value.empty) {
                          elementProps.field.onChange('');
                        } else {
                          elementProps.field.onChange('true');
                        }
                      }}
                    />
                    : props.fieldKey === 'expirationDate' ?
                      <CardExpiryElement
                        onChange={value => {
                          if (value.empty) {
                            elementProps.field.onChange('');
                          } else {
                            elementProps.field.onChange('true');
                          }
                        }}
                      />
                      : props.fieldKey === 'cvv' ?
                        <CardCvcElement
                          onChange={value => {
                            if (value.empty) {
                              elementProps.field.onChange('');
                            } else {
                              elementProps.field.onChange('true');
                            }
                          }}
                        />
                        : null
                  }
                </StripeInputBox>

                {elementProps.formState.errors[props.fieldKey] ? (
                  <ErrorMessage>
                    {errorMessage}
                  </ErrorMessage>
                ) : null}
              </>
            );
          }}
        />
      </>
    );
  };

  return StripeElementField;
}
